import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  Badge,
  MenuItem,
  Select,
  Avatar,
  Dialog,
  Fab,
  DialogContentText,
  DialogContent,
  DialogTitle
} from "@material-ui/core";

import {
  Visibility,
  VisibilityOff,
  WarningOutlined,
  CheckOutlined,
  Edit,
  EditOutlined,
  CheckBoxOutlined,
  CheckBoxOutlineBlankOutlined,
  ClearOutlined
} from "@material-ui/icons/";

import WorkOrderDetails from "../work-order-details/work-order-details";

const defaultFontSize = "2rem";

const styles = theme => ({
  formCls: {
    width: "100%"
  },
  root: {
    padding: ".5rem",
    width: "100%",
    overflowX: "auto"
  },
  table: {
    minWidth: 650
  },
  checkBoxColor: {
    color: "grey"
  },
  selected: {
    color: "#ff6c00 !important"
  },
  padding25: {
    padding: ".5rem"
  },
  margingrl25: {
    margin: "0 .25rem"
  },
  mb1: {
    marginBottom: ".5rem"
  },
  mb3: {
    marginBottom: "2rem"
  },
  mt5: {
    marginTop: "2rem"
  },
  storeFilter: {
    marginRight: ".5rem"
  },
   dflex: {
    display: "flex"
  },
  flexend:{
    justifyContent:'flex-end'
  },
  badgecls: {
    right: "-25px",
    backgroundColor: "#1c753be3"
  },
  tableBadgecls: {
    right: "1.25rem",
    top: "1.25rem",
    backgroundColor: " #1c753be3",
    fontSize: "1rem",
    minHeight: "2rem",
    borderRadius: "50%"
  },
  justifybetween: {
    justifyContent: "space-between"
  },
  flexgrow: {
    flexGrow: 1
  },
  openOrderArea: {
    maxHeight: "20rem",
    overflow: "auto"
  },
  headerBg1:{
    backgroundColor:"#1b3e71",
    color:"white",
    fontSize:".85rem"
  },
  sectionHeader:{
    backgroundColor: "#2b2a2a",
    color: "whitesmoke",
    marginBottom: ".25rem",
  },
  cursorPointer:{
    cursor:"pointer;"
  },
  headerStyle: {
    color: "#6975c3"
  },
});

class StoreHistory extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      rows: [],

      filterTerm: "",
      selectedStore: -99,
      storeItems: [],

      openColumns: [],
      openRows: [],

      closedColumns: [],
      closedRows: [],

      workOrderIsVisible: false,
      workOrder: 0,
      storeId: 0
    };
  }

  resetTables(){
    this.setState({
      openColumns: [],
      openRows: [],
      closedColumns: [],
      closedRows: []
    })
  }

  componentWillMount = () => {
    this.getStoreListing();
  };

  getOpenWorkOrders = () => {

    let url = this.state.isProd ? "/api/getOpenWorkOrders" : "https://localhost:44331/api/getOpenWorkOrders";

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerId: this.props.customerDetail.Id,
        storeId: this.state.selectedStore
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        if(resultFormed.results.length < 1)
        {
            return;
        }
        let data = this.parseData(resultFormed.results);

        this.setState({
          openColumns: data.columnNames,
          openRows: data.rows
        });
      },
      error: result => {
        console.error(result);
      }
    });
  };

  getClosedWorkOrders = () => {

    let url = this.state.isProd ? "/api/getClosedWorkOrders" : "https://localhost:44331/api/getClosedWorkOrders";

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerId: this.props.customerDetail.Id,
        storeId: this.state.selectedStore,
        count: 10
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        if(resultFormed.results.length < 1)
        {
            return;
        }

        let data = this.parseData(resultFormed.results);

        this.setState({
          closedColumns: data.columnNames,
          closedRows: data.rows
        });
      },
      error: result => {
        console.error(result);
      }
    });
  };

  parseData = data => {
    let columnNames = Object.keys(data[0]);
    let rows = Object.values(data);

    return { columnNames, rows };
  };

  getStoreListing() {
    
    let url = this.state.isProd ? "/api/store" : "https://localhost:44331/api/store";

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerId: this.props.customerDetail.Id,
        filterterm: this.state.filterTerm
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        
        this.setState({
          storeItems: resultFormed.items
        });

        this.resetTables();
      },
      error: result => {
        console.error(result);
      }
    });
  }

  getWorkOrders = () =>{
    this.getOpenWorkOrders();
    this.getClosedWorkOrders();
  }

  handleStoreFilterChange = evt => {
    this.setState(
      {
        filterTerm: evt.target.value
      },
      () => this.getStoreListing()
    );
  };

  handleStoreSelection = evt => {
    this.resetTables();

    this.setState({
      selectedStore: evt.target.value
    },
    () => this.getWorkOrders() 
    );
  };

 
  handleRowClick = item => {
    
    this.setState({
      storeId:item.StoreID,
      workOrder:item.OrderNumber,
      workOrderIsVisible:true
    })
  };

  handleClose = () => {
    this.setState({
      workOrderIsVisible: false
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={[classes.dflex, classes.flexgrow].join(" ")}>
        <Paper className={classes.root}>

        <Typography
          variant="h4"
          gutterBottom
          align="center"
          className={classes.headerStyle}
        >
          Store History
        </Typography>

          <div className={[classes.dflex, classes.mb3].join(" ")}>
            <FormControl className={classes.storeFilter}>
              <InputLabel
                htmlFor="adornment-password"
                className={classes.inputField}
              >
                <Badge
                  classes={{ badge: classes.badgecls }}
                  color="secondary"
                  max={999}
                  badgeContent={this.state.storeItems.length}
                >
                  StoreFilter
                </Badge>
              </InputLabel>

              <Input
                className={classes.inputField}
                id="adornment-password"
                type="text"
                value={this.state.textValue}
                onChange={this.handleStoreFilterChange}
              />
            </FormControl>

            <FormControl required className={classes.storeSelect}>
              <InputLabel htmlFor="age-required">Store</InputLabel>

              <Select
                value={this.state.selectedStore}
                onChange={this.handleStoreSelection}
                name="age"
                inputProps={{
                  id: "age-required"
                }}
                className={classes.selectEmpty}
              >
                <MenuItem value={-99} disabled>
                  <em>Select Store</em>
                </MenuItem>
                {this.state.storeItems.map(item => {
                  return (
                    <MenuItem
                      value={item.Id}
                      key={item.StoreDetails.StoreNumber}
                    >
                      {item.StoreDetails.CustomerAbbreviation +
                        " - " +
                        item.StoreDetails.StoreNumber}
                    </MenuItem>
                  );
                })}
              </Select>
              {/* <FormHelperText>Required</FormHelperText> */}
            </FormControl>
          </div>
          
          
          <Paper className={[classes.padding25, classes.mb5, classes.sectionHeader].join(" ")}>
            <Typography
              variant="h5"
              gutterBottom
              className={[classes.dflex, classes.justifybetween].join(" ")}
            >
              Open Work Orders
              <Badge
                classes={{ badge: classes.tableBadgecls }}
                color="secondary"
                max={999}
                showZero={true}
                badgeContent={this.state.openRows.length}
              >{""}</Badge>
            </Typography>
          </Paper>
          <div className={classes.openOrderArea}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell
                    align="center"
                    key={"row"}
                    classes={{ head: classes.headerBg1 }}
                  >
                    Row
                  </TableCell> */}
                  {this.state.openColumns.map(column => (
                    <TableCell
                      align="center"
                      key={column}
                      classes={{ head: classes.headerBg1 }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.openRows.map((row, index) => (
                  <TableRow
                    classes={{ hover: classes.cursorPointer }}
                    key={index}
                    hover
                    onClick={() => this.handleRowClick(row)}
                  >
                    {/* <TableCell align="center" key={"row"}>
                      {index}
                    </TableCell> */}
                    {this.state.openColumns.map(column => (
                      <TableCell align="center" key={row[column]}>
                        {row[column]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          
          <Paper className={[classes.padding25, classes.mb5, classes.sectionHeader].join(" ")}>
            <Typography
              variant="h5"
              gutterBottom
              className={[classes.dflex, classes.justifybetween].join(" ")}
            >
               Completed Work Orders (last 10)
              <Badge
                classes={{ badge: classes.tableBadgecls }}
                color="secondary"
                max={999}
                showZero={true}
                badgeContent={this.state.closedRows.length}
              >{""}</Badge>
            </Typography>
          </Paper>
          <div className={classes.openOrderArea}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell
                    align="center"
                    key={"row"}
                    classes={{ head: classes.headerBg1 }}
                  >
                    Row
                  </TableCell> */}
                  {this.state.closedColumns.map(column => (
                    <TableCell
                      align="center"
                      key={column}
                      classes={{ head: classes.headerBg1 }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.closedRows.map((row, index) => (
                  <TableRow
                    classes={{ hover: classes.cursorPointer }}
                    key={index}
                    hover
                    onClick={() => this.handleRowClick(row)}
                  >
                    {/* <TableCell align="center" key={"row"}>
                      {index}
                    </TableCell> */}
                    {this.state.closedColumns.map(column => (
                      <TableCell align="center" key={row[column]}>
                        {row[column]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>


          <Dialog
            fullWidth={true}
            maxWidth="xl"
            // fullScreen
            open={this.state.workOrderIsVisible}
            onClose={this.handleClose}                
          >
            <DialogTitle id="alert-dialog-title" className={[classes.dflex, classes.flexend].join(" ")}>
            <Fab color="primary" title="Close" className={classes.fab} onClick={this.handleClose}>
            <ClearOutlined />
          </Fab>
            </DialogTitle>
            <DialogContent>
              <WorkOrderDetails workOrder={this.state.workOrder} storeid={this.state.storeid}></WorkOrderDetails>
            </DialogContent>
            
          </Dialog>

        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(StoreHistory);
